async function checkZipCodeForSurcharge(ipapiKey, surcharge_zip_codes) {
  var zipcode = "";
  var country_code = "";

  const discountsAreActive = checkDiscountsDateRange();
  const volumeDiscountsAreActive = checkDiscountsDateRange("volume");
  let applyDiscount = false;
  let applyVolDiscount = false;
  const setLsDiscounts = (applyDiscount, applyVolDiscount) => {
    localStorage.setItem("applyDiscount", applyDiscount);
    localStorage.setItem("applyVolDiscount", applyVolDiscount);
  }
  let resExpired = await getZipByIpExpired(true);
  zipcode = resExpired.zip;
  country_code = resExpired.country_code;

  if (zipcode && zipcode.length) {
    const oldZipcode = localStorage.getItem('detectedZipcode');
    if(oldZipcode !== zipcode) {
      if(typeof kanopiSurcharge._setZoneByApi === 'function') kanopiSurcharge._setZoneByApi(zipcode);
      localStorage.setItem("detectedZipcode", zipcode);
      localStorage.setItem("detectedCountryCode", country_code);
    }
  }else{
    console.log("no detected zipcode:", zipcode)
  }

  // identifying if zipcode list is string or Array and converting it to array if it's a string as on deva nd production some times it's string for some user and browser
  let surchargeZipcodePatterns =
    typeof surcharge_zip_codes == "string"
      ? JSON.stringify(surcharge_zip_codes)
          .replaceAll("'", "")
          .slice(2, -2)
          .split(",")
      : surcharge_zip_codes === null ? [] : surcharge_zip_codes;
  const zipcodes = surchargeZipcodePatterns.filter(function (pattern) {
    // Exclude sequences that end with a wildcard
    return pattern.substr(pattern.length - 1) !== "*";
  });
  const zipcodePrefixes = surchargeZipcodePatterns
    .filter(function (pattern) {
      // Only include sequences that end with a wildcard
      return pattern.substr(pattern.length - 1) === "*";
    })
    .map(function (prefix) {
      return prefix.replace("*", "");
    });

  if (zipcodes && zipcodes.indexOf(zipcode) !== -1) {
    setLsDiscounts(false, false);
    return response;
  }

  // Try all prefixes and see if any match the zipcode
  const matchedPrefix = zipcodePrefixes.filter(function (prefix) {
    const zipStart = zipcode.substr(0, prefix.length);
    return zipStart === prefix;
  });

  if (zipcodePrefixes && matchedPrefix.length > 0) {
    setLsDiscounts(false, false);
    return response;
  }
  if (discountsAreActive) {
    document.querySelector("body").classList.add("not-surcharge-area");
    applyDiscount = true;
  }
      
  if (volumeDiscountsAreActive) {
    document.querySelector("body").classList.add("not-surcharge-area-vol");
    applyVolDiscount = true;
  }

  setLsDiscounts(applyDiscount, applyVolDiscount);
  return false;
}

//Overwrite checkDateRange function to always have it ready on the file.
function checkDiscountsDateRange(discountType = "regular") {
  if (
    typeof disableDsc === "undefined" ||
    typeof disableVolDsc === "undefined" ||
    typeof dscStartDate === "undefined" ||
    typeof dscEndDate === "undefined"
  )
    return false;
      
  const disable_dsc = discountType === 'regular' ? disableDsc : disableVolDsc;
  let apply_discounts = false;
  if ( disable_dsc !== "true") {
    const now = new Date();
    const start_date = getEstTimeZone(dscStartDate);
    const end_date = getEstTimeZone(dscEndDate);
    if (now > start_date && now <= end_date) {
      apply_discounts = true;
    }
  }
  if(discountType === 'volume' && typeof kanopiSurcharge !== 'undefined' && apply_discounts === true) {
    const surcharge = kanopiSurcharge._getSurchargeAmount();
    const isLowcharge = surcharge !== false && surcharge.includes('-');
    if (
      (typeof enable_vol_surcharge !== "undefined" &&
        enable_vol_surcharge != "true" &&
        surcharge !== "0" &&
        !isLowcharge) ||
      (typeof enable_vol_lowcharge !== "undefined" &&
        enable_vol_lowcharge != "true" &&
        surcharge !== "0" &&
        isLowcharge)
    ) {
      return false
    }
  }
  return apply_discounts;
}

if(typeof ipapiKey !== 'undefined' && typeof surcharge_zip_codes !== 'undefined') {
  checkZipCodeForSurcharge(ipapiKey, surcharge_zip_codes);
}
